<template>
  <abk-surveys-list surveys-type="active"/>
</template>

<script>
import AbkSurveysList from '../../../components/surveys/AbkSurveysList'
export default {
  name: 'ActiveSurveysTab',
  components: { AbkSurveysList },
  methods: {
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.surveys.list_tabs.active_surveys_tab.title'),
        subtitle: this.$t('views.surveys.list_tabs.active_surveys_tab.subtitle')
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>

<style scoped>

</style>
